module.exports = __webpack_public_path__ + "img/use-coupon.20264fe.gif";